import { useQuery } from "@tanstack/react-query";
import useCompanyIdFromUrl from "@/hooks/companies/useCompanyIdFromUrl";
import apiClient from "@/modules/request.module.v2";

export default (queryOptions) => {
  const companyId = useCompanyIdFromUrl();

  const query = useQuery({
    ...queryOptions,
    queryKey: ["latestShareData", companyId],
    queryFn: () => {
      return apiClient.get("shares/transactions/last/sharedata", {
        headers: {
          "x-company-id": companyId,
        },
      });
    },
    retry: (failureCount, error) =>
      error?.response?.status === 401
        ? false // Don't retry on 401 when unauthorized
        : failureCount < 3,
  });

  return query;
};
